import { IIconBuilder } from 'interfaces/iconBuilder'
import { IOption, IOptionWithIcon } from 'types/common'
import { getValidArray } from 'utils/common'
import { getName } from 'utils/users'
import { ECollectionFilterName } from './contants'

export function getOptionSelect<T extends { id?: number; name?: string; iconBuilder?: IIconBuilder }>(
  items: T[]
): IOptionWithIcon<string>[] {
  let itemOptions: IOptionWithIcon<string>[] = []
  let options: string[] = []
  getValidArray(items).forEach((item: T) => {
    if (!options.includes(String(item?.id ?? '')) && (item?.name || !!getName(item))) {
      options = options.concat(String(item?.id))
      itemOptions = [
        ...itemOptions,
        {
          value: String(item?.id),
          label: item?.name ?? getName(item) ?? '',
          icon: item?.iconBuilder
        }
      ]
    }
  })
  return itemOptions
}

export function getItemIds(params: URLSearchParams, collectionName: string): number[] {
  return params.get(collectionName)
    ? (params
        .get(collectionName)
        ?.split(',')
        ?.map((id: string) => Number(id)) ?? [])
    : []
}

export function filterCurrentItems<T extends { id?: number; name?: string }>(
  params: URLSearchParams,
  name: string,
  itemList: T[]
): T[] {
  const itemIds: number[] = getItemIds(params, name)

  const currentItems = getValidArray(itemList).filter(item => itemIds.includes(item?.id ?? 0))
  return currentItems
}

export function filterRemainItem<T extends { id?: number; name?: string }>(
  itemList: T[],
  selectedItem: IOption<string>[]
): T[] {
  const item = getValidArray(itemList).filter(
    (group: T) => !getValidArray(selectedItem).find((option: IOption<string>) => option?.value === String(group?.id))
  )

  return item
}

export function filterSubmitItems(selectedItems: IOption<string>[]): string {
  return selectedItems.map(item => item?.value).join(',')
}
